import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { SearchBar } from '@components/SearchBar'
import { Refresh } from '@components/Refresh'
import { DraggableItem } from '@components/DragAndDrop'

import { useSequenceTemplates } from '@hooks/sequence-template/sequence-templates.hook'

import { SequenceTemplateThumb } from '../../SequenceTemplateThumb'

import { Container } from './SequenceTemplateList.styled'

export const SequenceTemplateList = (): JSX.Element => {
  const { t } = useTranslation()

  const [search, setSearch] = useState<string>('')

  const { projectId } = useParams()

  const { data, loading, error, refetch } = useSequenceTemplates(projectId || '')

  const isLoading = loading ? 1 : error ? -1 : 0

  const sequences = data?.sequenceTemplates || []

  const filteredSequenceTemplates = sequences
    .filter((sequence) => sequence.name.toLowerCase().indexOf(search.toLowerCase()) != -1)
    .sort((a, b) => (a.index < b.index ? -1 : 1))

  return (
    <Container>
      <SearchBar
        className="search-bar"
        placeholder={t('modules_project-settings_pages_sequences_label_search_field')}
        value={search}
        onChange={(value) => setSearch(value)}
      />

      <Refresh loading={isLoading} small onRefresh={() => refetch(projectId || '')}>
        {filteredSequenceTemplates.length > 0 &&
          filteredSequenceTemplates.map((sequence) => (
            <DraggableItem key={sequence.id} id={sequence.id} data={{ sequence }}>
              <SequenceTemplateThumb sequence={sequence} />
            </DraggableItem>
          ))}
      </Refresh>
    </Container>
  )
}
